import { API_BASE_URL } from '../config/runtime';
import { apiRequest, clearBackendToken, setBackendSession } from './client';

export const backendAuth = {
  async register({ email, userHandle, password, language }) {
    return apiRequest('/api/v1/auth/register', {
      method: 'POST', body: { email, userHandle, password, language }, skipAuth: true,
    });
  },
  async login(login, password, language) {
    const response = await apiRequest('/api/v1/auth/login', {
      method: 'POST', body: { login, password, language }, skipAuth: true,
    });
    setBackendSession(response.accessToken, response.refreshToken);
    return response;
  },
  me() {
    return apiRequest('/api/v1/auth/me', { notifyAuthFailure: false });
  },
  async issueSession() {
    const response = await apiRequest('/api/v1/auth/session', { method: 'POST' });
    setBackendSession(response.accessToken, response.refreshToken);
    return response;
  },
  async logout() {
    // Accept the server's expired Set-Cookie even when authenticating with a bearer.
    try { await apiRequest('/api/v1/auth/logout', { method: 'POST', credentials: 'include' }); }
    // Do not emit an auth-change event while logout is in progress. That event
    // would start /auth/me restoration before the server has finished clearing
    // its session cookie and could immediately sign the user back in.
    finally { clearBackendToken({ notify: false }); }
  },
  resendVerification(email, language) {
    return apiRequest('/api/v1/auth/email/resend', { method: 'POST', body: { email, language }, skipAuth: true });
  },
  verifyEmail(token) {
    return apiRequest('/api/v1/auth/email/verify', { method: 'POST', body: { token }, skipAuth: true, credentials: 'omit' });
  },
  forgotPassword(email, language) {
    return apiRequest('/api/v1/auth/password/forgot', { method: 'POST', body: { email, language }, skipAuth: true });
  },
  resetPassword(token, newPassword) {
    return apiRequest('/api/v1/auth/password/reset', { method: 'POST', body: { token, newPassword }, skipAuth: true, credentials: 'omit' });
  },
  requestAccountDeletion(password) {
    return apiRequest('/api/v1/me/account-deletion', { method: 'POST', body: { password } });
  },
  googleAuthorizationUrl: `${API_BASE_URL}/oauth2/authorization/google`,
};
